/** @format */
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FudisDialogService } from '@funidata/ngx-fudis';
import { CreditRange } from 'common-typescript/types';

export interface PlannedStudyTerm {
    readonly startYear: number;
    /** Localized name of the study term. */
    readonly name: string;
    /** Localized names of the planned study periods of the study term. */
    readonly periodNames: readonly string[];
}

export interface TimelineMultiPeriodTimingDialogData {
    /** Localized name of the study timed to multiple study periods. */
    readonly studyName: string;
    readonly credits: CreditRange;
    readonly studyTerms: readonly PlannedStudyTerm[];
}

export function timelineMultiPeriodTimingDialogOpener(): (
    data: TimelineMultiPeriodTimingDialogData,
) => MatDialogRef<TimelineMultiPeriodTimingDialogComponent, null> {
    const fudisDialogService = inject(FudisDialogService);
    return data =>
        fudisDialogService.open<TimelineMultiPeriodTimingDialogComponent, null, TimelineMultiPeriodTimingDialogData>(
            TimelineMultiPeriodTimingDialogComponent,
            { data },
        );
}

/**
 * Lists the study terms and study periods a study has been timed to.
 */
@Component({
    selector: 'app-timeline-multi-period-timing-dialog',
    standalone: false,
    templateUrl: './timeline-multi-period-timing-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineMultiPeriodTimingDialogComponent {
    protected readonly data: TimelineMultiPeriodTimingDialogData = inject(MAT_DIALOG_DATA);
}
